import { appAnalytics } from 'analytics';
import { SaveAnswer } from 'analytics/AllEvents';
import { useAppDispatch, useAppSelector } from 'bootstrap/hooks';
import { setAnswer } from 'bootstrap/onboarding/actions';
import { SyntheticEvent, useEffect, useMemo, useState } from 'react';
import {
  RELATE_SCALE_OPTIONS,
  Option,
} from './LivenStatementQuestion.constants';
import { useFeatures } from 'useFeatures';
import { LivenStatementQuestion } from 'onboarding/question/livenstatement/LivenStatementQuestion';

export const useLivenStatementQuestionLogic = (
  question: LivenStatementQuestion,
) => {
  const dispatch = useAppDispatch();

  const { answers } = useAppSelector((state) => state.onboarding);

  const [activeOption, setActiveOption] = useState<string>('');
  const [containerStyle, setContainerStyle] = useState<string>('');
  const [isLeaving, setLeaving] = useState<boolean>(false);

  const features = useFeatures();

  const options: Option[] = useMemo(() => {
    return RELATE_SCALE_OPTIONS;
  }, [question]);

  useEffect(() => {
    const currentAnswer = answers[question.id];
    setContainerStyle('enter');
    setLeaving(false);
    if (currentAnswer && typeof currentAnswer === 'string') {
      setActiveOption(currentAnswer);
    } else {
      setActiveOption('');
    }
  }, [question]);

  const optionHandler = (option: Option) => (e: SyntheticEvent) => {
    e.preventDefault();

    if (!isLeaving) {
      setActiveOption(option.id);
      setLeaving(true);
      setContainerStyle('leave');

      appAnalytics.trackEvent(new SaveAnswer(question.id, option.id));
      dispatch(setAnswer(question.id, option.id, features));

      // Allow another selection after a delay
      setTimeout(() => setLeaving(false), 500);
    }
  };

  return {
    activeOption,
    containerStyle,
    options,
    optionHandler,
  };
};
